'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function VideoOverlay() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultProps;
  var className = props.className,
      onClick = props.onClick;


  return _react2.default.createElement('div', {
    className: className,
    onClick: onClick });
}

VideoOverlay.propTypes = {
  className: _react.PropTypes.string,
  placement: _react.PropTypes.string.isRequired,
  onClick: _react.PropTypes.func
};

VideoOverlay.defaultProps = {
  className: _react.PropTypes.string,
  placement: 'OVER_VIDEO',
  onClick: function onClick() {}
};

exports.default = VideoOverlay;